import React from 'react';
import CTA from "../../../../components/Constant/cta/CTA";
import WhySection from "../../../../components/WhySection/WhySection";
import IntroSection from "../../../../components/IntroSection/IntroSection";
import FAQList from "../../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../../components/InfoBlocks/InfoBlocks";
import {Helmet} from "react-helmet";
import ServiceCards from "../../../../components/ServiceCards/ServiceCards";

export default function NetherlandsCompanySale() {

    return (
        <main className='main'>
            <Helmet>
                <title>Netherlands Company for Sale | Buy Ready-Made Dutch Company</title>
                <meta name="description" content="Buy a ready-made Netherlands company with expert support. Fast, compliant acquisition with EU market access and full setup services." />
                <meta name="keywords" content="
                    Netherlands company for sale, buy Dutch company, ready made company Netherlands, shelf company Netherlands, BV company for sale, NV company Netherlands, EU company formation, company acquisition Netherlands, Dutch company setup, Netherlands business for sale, ready made BV Netherlands, offshore company Netherlands, company transfer Netherlands, European company setup, Netherlands holding company, business expansion Europe, Dutch corporate services, company purchase Netherlands, EU business entry, Netherlands incorporation services
                "
                />
            </Helmet>

            <IntroSection
                title="Netherlands Company for Sale | Offshore Advisory"
                description=
                    {
                        `
                        Acquire a ready-made company in the Netherlands and start operating immediately in one of Europe’s most stable and business-friendly economies. Offshore Advisory provides fully compliant, pre-registered Dutch companies for entrepreneurs, investors, and international businesses looking for a fast market entry.
                        <br/>
                        <br/>
                        With a strong legal system, excellent reputation, and access to the European Union, the Netherlands is a top destination for international trade, holding structures, and operational businesses. Our ready-made companies allow you to bypass lengthy incorporation procedures and begin operations right away.
                    `
                    }
                buttonText="Request a Netherlands Company Proposal →"
                buttonLink="/quote"
                imageSrc={require('../../../../assets/images/Netherlands Company for Sale 4.jpg')}
                imageAlt="Panama Gaming License"
            />


            <section className='section'>
                <div className="container">

                    <DetailsSection
                        title="Why Choose a Netherlands Ready-Made Company?"
                        items={[
                            {
                                title: "Immediate Availability",
                                text: "Start operations without waiting for incorporation."
                            },
                            {
                                title: "EU Market Access",
                                text: "Trade freely within the European Union."
                            },
                            {
                                title: "Strong Reputation",
                                text: "Dutch companies are globally trusted and credible."
                            },
                            {
                                title: "Stable Legal Framework",
                                text: "Transparent and business-friendly regulations."
                            },
                            {
                                title: "Tax Efficiency",
                                text: "Attractive corporate tax structure with treaty benefits."
                            },
                        ]}
                    />

                    <h1 className='page-title'>
                        Our Services & Step-by-Step Acquisition Process
                    </h1>
                    <p className='page-paragraph'>
                        At Offshore Advisory, we provide end-to-end support to help you acquire and operate your Netherlands company smoothly and compliantly.
                    </p>

                    <WhySection
                        title='1. Consultation & Company Selection'
                        subtitle="We begin by understanding your business needs and selecting the right company. What we do:"
                        blocks={[
                            {
                                items: [
                                    {
                                        text: " Identify suitable ready-made companies based on your objectives",
                                    },
                                    {
                                        text: "Advise on structure (BV, NV, holding company, etc.)"
                                    },
                                    {
                                        text: "Provide full details of company history and status"
                                    },

                                ]
                            }
                        ]}
                    />

                    <WhySection
                        title='2. Due Diligence & Verification'
                        subtitle='We ensure the company is clean, compliant, and ready for transfer. Our support includes:'
                        blocks={[
                            {
                                items: [
                                    {
                                        text: "Verification of company records and history"
                                    },
                                    {
                                        text: "Ensuring no liabilities, debts, or legal issues"
                                    },
                                    {
                                        text: "Providing transparency on company status"
                                    },
                                ]
                            }
                        ]}
                    />

                    <WhySection
                        title='3. Ownership Transfer & Documentation'
                        subtitle='We handle the legal transfer of ownership efficiently. Our services cover:'
                        blocks={[
                            {
                                items: [
                                    {
                                        text: "Drafting and executing share transfer agreements"
                                    },
                                    {
                                        text: "Updating company directors and shareholders"
                                    },
                                    {
                                        text: "Notarization and official registration updates"
                                    },
                                ]
                            }
                        ]}
                    />
                    <WhySection
                        title='4. Bank Account Setup & Operational Readiness'
                        subtitle='We help you get your company fully operational.'
                        blocks={[
                            {
                                items: [
                                    {
                                        text: "Assistance with opening corporate bank accounts"
                                    },
                                    {
                                        text: "Support with payment systems and financial setup"
                                    },
                                    {
                                        text: "Guidance on operational requirements"
                                    },

                                ]
                            }
                        ]}
                    />
                    <WhySection
                        title='5. Ongoing Compliance & Corporate Support'
                        subtitle='After acquisition, we ensure your company remains compliant.'
                        blocks={[
                            {
                                items: [
                                    {
                                        text: "Ongoing bookkeeping and reporting support"
                                    },
                                    {
                                        text: "Corporate governance and legal compliance"
                                    },
                                    {
                                        text: "Advisory on tax and regulatory obligations"
                                    },

                                ]
                            }
                        ]}
                    />


                    <InfoBlocks
                        blocks={[
                            {
                                title: "Why This Approach Matters",
                                subtitle: "By combining ready-made solutions with expert advisory, Offshore Advisory ensures your Netherlands company acquisition is:",
                                items: [
                                    {
                                        title: "Fast",
                                        text: "Immediate business operations"
                                    },
                                    {
                                        title: "Secure",
                                        text: "Fully verified and compliant companies"
                                    },
                                    {
                                        title: "Transparent",
                                        text: "Clear documentation and ownership transfer"
                                    },
                                    {
                                        title: "Scalable",
                                        text: "Structured for growth in European markets"
                                    }
                                ]
                            },

                        ]}
                    />


                    <InfoBlocks
                        blocks={[
                            {
                                title: "Types of Companies Available",
                                items: [
                                    {
                                        title: "BV (Besloten Vennootschap)",
                                        text: "Private limited company ideal for SMEs and startups"
                                    },
                                    {
                                        title: "NV (Naamloze Vennootschap)",
                                        text: "Public limited company for larger enterprises"
                                    },
                                    {
                                        title: "Holding Companies",
                                        text: "For asset management and international structuring"
                                    },
                                    {
                                        title: "Trading Companies",
                                        text: "Ready for import/export and EU operations"
                                    }
                                ]
                            }
                        ]}
                    />

                    <ServiceCards
                        title='Who Can Benefit?'
                        services={
                            [
                                {
                                    title: "Entrepreneurs & Startups",
                                    text: "Enter the EU market quickly"
                                },
                                {
                                    title: "International Businesses",
                                    text: "Expand operations into Europe",
                                },
                                {
                                    title: "Investors & Holding Structures",
                                    text: "Optimize global business strategies",
                                },
                                {
                                    title: "E-commerce & Trading Companies",
                                    text: "Benefit from EU access and logistics",
                                },
                            ]
                        }
                        end="Owning a Netherlands company positions your business in one of Europe’s most reputable and strategic jurisdictions."
                    />


                    <Testimonials
                        title="Our Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    <FAQList data={faqData} title='FAQs – Netherlands Company for Sale'/>

                    <CTA
                        title="Contact Offshore Advisory Today!"
                        description="Ready to acquire your Netherlands company and start operating immediately? Offshore Advisory ensures a fast, secure, and compliant process."
                        buttonText="Get Started Today →"
                        buttonLink="/quote"
                    />

                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "What is a ready-made company?",
        answer: "A pre-registered company that is already incorporated and available for immediate transfer."
    },
   {
        question: "How long does the acquisition process take?",
        answer: "Typically a few days to 1–2 weeks depending on documentation and approvals."
    },
   {
        question: "Can non-residents buy a Netherlands company?",
        answer: "Yes, foreign individuals and entities can acquire Dutch companies."
    },
   {
        question: "Does the company come with a bank account?",
        answer: "Some companies may include bank accounts, or we assist in opening one."
    },
    {
        question: "Are these companies free from liabilities?",
        answer: "Yes, all companies undergo due diligence to ensure they are clean and compliant."
    },

];

const testimonialsData = [
    {
        quote: "Offshore Advisory helped us acquire a Dutch company within days. The process was seamless and fully transparent.",
        author: "Daniel R.",
        role: "International Investor"
    },
    {
        quote: "Their team handled everything from due diligence to banking. We were operational in no time.",
        author: "Laura S.",
        role: "Business Owner"
    },

];

